import { KeyValue } from '@angular/common';
import {
    Component,
    ContentChildren,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    QueryList,
    TemplateRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataTableConfig } from '../shared.interface';

@Component({
    selector: 'app-data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss'],
})
export class DataTableComponent implements OnInit {
    @Input() tableData: DataTableConfig;
    @Input() parentForm: FormGroup;
    @Input() pagination = false
    @Input() page = 1;
    @Input() pageSize = 10;
    @Input() noticeMessage : string = '';


    @Output() checkboxValueChanged = new EventEmitter();
    @Output() refreshButtonClicked = new EventEmitter();
    @Output() toggleButtonClicked = new EventEmitter();
    @Output() revertLink = new EventEmitter();


    objectkeys = Object.keys;
    detailTemplateRefs: TemplateRef<any>[];

    @ContentChildren('detailTemplate') detailRows: QueryList<ElementRef>;

    get serializedPanes(): string {
        return this.detailRows ? this.detailRows.map((p) => p).join(', ') : '';
    }

    documentValidityIconConfig = [
        {
            showIcon: true,
            icon: 'assets/images/success-status-icon.png',
            content: '',
            style: '26px',
        },
    ];

    constructor() {}

    ngOnInit(): void {
    }

    originalOrder = (
        a: KeyValue<number, string>,
        b: KeyValue<number, string>
    ): number => {
        return 0;
    };

    documentValidityIcon(value): any {
        const documentValidityIconConfig = {
            showIcon: true,
            icon: 'assets/images/success-status-icon.png',
            content: '',
            style: '26px',
        };

        if (value === 'false') {
            documentValidityIconConfig.icon =
                'assets/images/failure-status-icon.png';
            documentValidityIconConfig.style = '40px';
        }

        return documentValidityIconConfig;
    }

    masterTableCell(key: string): boolean {
        if (
            key === 'rowSelected' ||
            key === 'rowDetails' ||
            key === 'rowDisabled'
        ) {
            return false;
        }
        return true;
    }

    showValue(key): boolean {
        if (
            key !== 'documentValidity' &&
            key !== 'documentValidityByDuration' &&
            key !== 'refreshEnabled' &&
            key !== 'documentCheckedByNotary' &&
            key !== 'action' &&
            key !== 'buyersAfm' &&
            key !== 'sellersAfm' &&
            key !== 'documentValidityDuration' &&
            key !== 'rowSelected' &&
            key !== 'rowDetails'
        ) {
            return true;
        }

        return false;
    }

    onRowClick(index: number): void {
        this.tableData.rowClickCallback(index);
    }

    onCheckboxValueChanged(rowData) {
        this.checkboxValueChanged.emit(rowData);
    }
    onRefresh(rowData, id) {
        this.refreshButtonClicked.emit({ ...rowData, id });
    }

    onToggleChange(rowData) {
        this.toggleButtonClicked.emit(rowData);
    }

    onRevertLink(rowData, id) {
        this.revertLink.emit({ ...rowData, id });
    }

    get data() : any[]{
      if(this.pagination){
        const startIndex = (this.page -1 ) * this.pageSize;
        const endIndex = this.page * this.pageSize
        return this.tableData.data.slice(startIndex
          , endIndex )
      }
      return this.tableData?.data
    }
}
